/**
 * 描述：考核白名单维护
 * 日期：2018-08-21
 * 作者：qian.qianchen
 */
'use strict';
angular.module("whiteListManageModule", ['whiteListManageServiceModule'])
    .controller("whiteListManageCtrl", ["$scope", "trsspliceString", "$q", "$filter", "modalDialog", "trsHttpService", "whiteListManageService", function($scope, trsspliceString, $q, $filter, modalDialog, trsHttpService, whiteListManageService) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.status = {

            };
            $scope.data = {
                userInWhitelistArray: []
            };
        }
        /**
         * [initData description]初始化数据
         */
        function initData() {
            initUserInWhiteList();
        }
        /**
         * [initUserInWhiteList description]初始化考勤白名单人员列表
         * @return {[type]} [description]
         */
        function initUserInWhiteList() {
            var deffer = $q.defer();
            var params = {
                serviceid: "mlf_tenant",
                methodname: "showUserInWhitelist",
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                $scope.data.userInWhitelistArray = data;
                deffer.resolve(data);
            });
            return deffer.promise;
        }
        /**
         * [delPapersite description] 删除媒体
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.delPapersite = function(item) {
            modalDialog.alertType("确定删除该媒体及下属白名单人员吗？", "", "info", true, function() {
                var params = {
                    serviceid: "mlf_tenant",
                    methodname: "delPaperSiteWhitelist",
                    PAPERSITEID: item.PAPERSITEID
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    modalDialog.alertType("删除成功！", "", "success", false);
                    initUserInWhiteList();
                });
            });
        }
        /**
         * [addPapersite description] 新增媒体
         */
        $scope.addPapersite = function() {
            whiteListManageService.addPapersite().then(function() {
                initUserInWhiteList();
            });
        };
        /**
         * [addWhiteList description] 新增白名单
         * @param {[type]} item [description] 媒体对象
         */
        $scope.addWhiteList = function(item) {
            var selectedUsers = handleSelectedUser(item);
            whiteListManageService.getUser(function(data) {
                var params = {
                    "serviceid": "mlf_tenant",
                    "methodname": "saveUserInWhitelist",
                    "ADDUSERINFO": selectUserFormat(selectedUsers, data),
                    "PAPERSITEID": item.PAPERSITEID

                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    modalDialog.alertType("添加白名单成功", "", "success", false, function() {
                        initUserInWhiteList();
                    });
                });
            });
        };
        /**
         * [editWhiteList description] 编辑白名单
         * @param {[type]} item [description] 媒体对象
         */
        $scope.editWhiteList = function(item) {
            var selectedUsers = handleSelectedUser(item);
            whiteListManageService.getUser(function(data) {
                var params = {
                    "serviceid": "mlf_tenant",
                    "methodname": "saveUserInWhitelist",
                    "ADDUSERINFO": selectUserFormat(selectedUsers, data),
                    "DELUSERINFO": unSelectUserFormat(selectedUsers, data),
                    "PAPERSITEID": item.PAPERSITEID

                };

                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    modalDialog.alertType("编辑白名单成功", "", "success", false, function() {
                        initUserInWhiteList();
                    });
                });
            }, "", angular.copy(selectedUsers));
        };
        /**
         * [getObjFromArr description] 根据指定属性值获取数组中的对象
         * @param  {[type]} arr      [description] 数组
         * @param  {[type]} property [description] 属性名
         * @param  {[type]} value    [description] 属性值
         * @return {[type]}          [description]
         */
        function getObjFromArr(arr, property, value) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][property] == value) {
                    return arr[i];
                }
            }
            return false;
        }
        /**
         * [selectUserFormat description] 已选用户格式化
         * @param  {[type]} oldVal [description] 原选中用户数组
         * @param  {[type]} newVal [description] 现选中用户数组
         * @return {[type]}        [description]
         */
        function selectUserFormat(oldVal, newVal) {
            var addArr = [];
            var oldIdArr = oldVal.map(function(item) {
                return item.ID;
            });
            var newIdArr = newVal.map(function(item) {
                return item.ID;
            });
            newIdArr.forEach(function(item, index) {
                if (oldIdArr.indexOf(item) < 0) {
                    var addObj = getObjFromArr(newVal, 'ID', item);
                    addArr.push({ "groupId": addObj.GROUPID, "userId": addObj.ID });
                }
            });
            return addArr.length == 0 ? '' : JSON.stringify(addArr);
        }
        /**
         * [unSelectUserFormat description] 已删除用户格式化
         * @param  {[type]} oldVal [description] 原选中用户数组
         * @param  {[type]} newVal [description] 现选中用户数组
         * @return {[type]}        [description]
         */
        function unSelectUserFormat(oldVal, newVal) {
            var delArr = [];
            var oldIdArr = oldVal.map(function(item) {
                return item.ID;
            });
            var newIdArr = newVal.map(function(item) {
                return item.ID;
            });
            oldIdArr.forEach(function(item, index) {
                if (newIdArr.indexOf(item) < 0) {
                    var delObj = getObjFromArr(oldVal, 'ID', item);
                    delArr.push({ "groupId": delObj.GROUPID, "userId": delObj.ID });
                }
            });
            return delArr.length == 0 ? '' : JSON.stringify(delArr);
        }
        /**
         * [handleSelectedUser description] 已选用户列表格式化
         * @param  {[type]} whiteList [description] 已选用户数组
         * @return {[type]}           [description]
         */
        function handleSelectedUser(whiteList) {
            var array = [];
            for (var i = 0; i < whiteList.DATA.length; i++) {
                for (var j = 0; j < whiteList.DATA[i].USERDATA.length; j++) {
                    array.push({
                        "ID": whiteList.DATA[i].USERDATA[j].USERID,
                        "NAME": whiteList.DATA[i].USERDATA[j].USERTRUENAME,
                        "DESC": whiteList.DATA[i].USERDATA[j].USERTRUENAME,
                        "GROUPDESC": whiteList.DATA[i].GROUPDESC,
                        "GROUPID": whiteList.DATA[i].GROUPID
                    });
                }
            }
            return array;
        }
        /**
         * [userFormat description] 用户列表显示样式格式化
         * @param  {[type]} item [description] 用户数据
         * @return {[type]}      [description]
         */
        $scope.userFormat = function(item) {
            item.users = '：';
            for (var i = 0; i < item.length; i++) {
                if (i === 0) {
                    item.users = item.users + item[i].USERTRUENAME;
                } else {
                    item.users = item.users + '、' + item[i].USERTRUENAME;
                }

            }
            return item.users;
        }
    }]);